import { Component, EventEmitter, inject, Input, ViewEncapsulation } from '@angular/core';
import { Session } from '@models/session';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CameraFeedComponent } from '../camera-feed/camera-feed.component';
import { IconDirective } from '../../directives/icon.directive';

@Component({
  selector: 'lv-verify-agent',
  styleUrls: ['verify-agent.component.scss'],
  templateUrl: 'verify-agent.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, CameraFeedComponent, IconDirective]
})
export class VerifyAgentComponent {
  private readonly translate = inject(TranslateService);

  private connecting = false;

  @Input() session: Session;
  @Input() connect: EventEmitter<null>;

  get isConnecting(): boolean {
    return this.connecting && !this.session.tokbox.connected;
  }

  get liveAgentConnected(): boolean {
    return this.session.liveAgentConnected;
  }

  get translatedLabel(): string {
    return this.translate.instant('app.' + this.labelToTranslate());
  }

  get icon(): string {
    if (this.isConnecting) {
      return 'spinner';
    } else if (this.liveAgentConnected) {
      return 'check';
    }

    return 'video-camera';
  }

  connectLiveAgent() {
    this.connecting = !this.connecting;
    this.connect.emit();
  }

  private labelToTranslate(): string {
    if (this.isConnecting) {
      return 'connecting';
    } else if (this.liveAgentConnected) {
      return 'connected';
    }
    return 'connect';
  }
}
